import { Component, ChangeDetectorRef } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import type { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  IconComponent,
  TextareaComponent,
} from '@core/user-interface-legacy';
import { LifeCycle } from '@core/utils-legacy';

@Component({
  selector: 'rt-submit-rejection-dialog',
  templateUrl: './submit-rejection-dialog.component.html',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    IconComponent,
    TextareaComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class SubmitRejectionDialogComponent implements DialogComponentI<void, string> {
  public messageControl = new FormControl('', Validators.required);

  @LifeCycle('onDestroy')
  private ngOnDestroy$: Subject<void>;

  constructor(
    private dialogRef: DialogRef<string>,
    private cdRef: ChangeDetectorRef,
  ) {
    this.messageControl.valueChanges
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => this.cdRef.detectChanges());
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean): void {}

  public submit(): void {
    this.dialogRef.close(this.messageControl.value);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
